import { render, staticRenderFns } from "./CountedTextarea.vue?vue&type=template&id=04498fda"
import script from "./CountedTextarea.vue?vue&type=script&lang=js"
export * from "./CountedTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports